import React from 'react';
import { motion } from 'framer-motion';
import { GlobeIcon, NetworkIcon, ShieldCheckIcon, PhoneCallIcon, ArrowRightIcon } from 'lucide-react';
const featuredServices = [{
  title: 'Business Internet Optimization',
  description: 'Most businesses overpay for internet by 25-40%. We audit your current plan, compare rates across every provider in your area, and negotiate the best possible deal — often saving thousands per year.',
  image: 'https://images.unsplash.com/photo-1451187580459-43490279c0fa?w=600&h=400&fit=crop',
  icon: GlobeIcon
}, {
  title: 'Fiber & Ethernet Savings',
  description: "Dedicated fiber doesn't have to break the bank. We leverage wholesale relationships and multi-year contract strategies to secure enterprise-grade connectivity at significantly reduced rates.",
  image: 'https://images.unsplash.com/photo-1516321318423-f06f85e504b3?w=600&h=400&fit=crop',
  icon: NetworkIcon
}, {
  title: 'Security Cost Consolidation',
  description: 'Eliminate redundant security vendors and overlapping services. We bundle enterprise-grade network protection into your telecom stack, reducing complexity and monthly spend simultaneously.',
  image: 'https://images.unsplash.com/photo-1550751827-4bd374c3f58b?w=600&h=400&fit=crop',
  icon: ShieldCheckIcon
}, {
  title: 'Phone System Cost Reduction',
  description: 'Legacy phone systems are one of the biggest hidden expenses. We migrate businesses to modern VoIP and UCaaS platforms that deliver better features at a fraction of the cost.',
  image: 'https://images.unsplash.com/photo-1553877522-43269d4ea984?w=600&h=400&fit=crop',
  icon: PhoneCallIcon
}];
export function FeaturedServices() {
  return <section className="py-24 bg-white" id="featured-services" data-id="element-62">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-63">
        <h2 className="text-3xl md:text-4xl font-bold text-slate-900 text-center mb-16" data-id="element-64">
          How We Reduce Your Expenses
        </h2>

        <div className="space-y-12" data-id="element-65">
          {featuredServices.map((service, i) => {
          const Icon = service.icon;
          const isReversed = i % 2 !== 0;
          return <motion.div key={i} initial={{
            opacity: 0,
            y: 24
          }} whileInView={{
            opacity: 1,
            y: 0
          }} viewport={{
            once: true,
            margin: '-60px'
          }} transition={{
            duration: 0.5
          }} className={`bg-slate-50 rounded-2xl overflow-hidden flex flex-col ${isReversed ? 'md:flex-row-reverse' : 'md:flex-row'}`} data-id="element-66">
                {/* Text content */}
                <div className="flex-1 p-8 md:p-12 flex flex-col justify-center" data-id="element-67">
                  <div className="w-10 h-10 bg-primary/10 rounded-lg flex items-center justify-center mb-4" data-id="element-68">
                    <Icon className="w-5 h-5 text-primary" data-id="element-69" />
                  </div>
                  <h3 className="text-2xl font-bold text-slate-900 mb-4" data-id="element-70">
                    {service.title}
                  </h3>
                  <p className="text-slate-600 leading-relaxed mb-6" data-id="element-71">
                    {service.description}
                  </p>
                  <div className="inline-flex items-center px-4 py-2 rounded-full bg-accent/10 text-accent text-sm font-bold mb-6" data-id="element-72">
                    <span className="flex h-2 w-2 rounded-full bg-accent mr-2 animate-pulse" data-id="element-73"></span>
                    Special Offer
                  </div>
                  <a href="#" className="inline-flex items-center text-primary font-semibold hover:text-primary-dark transition-colors group" data-id="element-74">
                    learn more
                    <ArrowRightIcon className="w-4 h-4 ml-2 transform group-hover:translate-x-1 transition-transform" data-id="element-75" />
                  </a>
                </div>

                {/* Image */}
                <div className="flex-1 min-h-[240px] md:min-h-[320px]" data-id="element-76">
                  <img src={service.image} alt={service.title} className="w-full h-full object-cover" data-id="element-77" />
                </div>
              </motion.div>;
        })}
        </div>
      </div>
    </section>;
}